import { useContext } from 'react';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import { useLayoutEffectWithoutSSRComplaining } from '@wix/da-hooks/pkg/useLayoutEffectWithoutSSRComplaining';
import { CommentEditorContext } from './context';
import { useEditorDraftState } from './hooks/useEditorDraftState';
/**
 * Triggers the loading/expansion of the commentbox when there is a draft
 * comment saved in local storage
 */
var DraftCommentAutoTrigger = function (_a) {
    var editorId = _a.editorId;
    var expandEditor = useContext(CommentEditorContext).expandEditor;
    var hasDraft = useEditorDraftState(editorId);
    var isMounted = useIsMounted();
    useLayoutEffectWithoutSSRComplaining(function () {
        if (!isMounted) {
            return;
        }
        if (hasDraft) {
            expandEditor();
        }
    }, [isMounted]);
    return null;
};
DraftCommentAutoTrigger.displayName = 'DraftCommentAutoTrigger';
export default DraftCommentAutoTrigger;
//# sourceMappingURL=DraftCommentAutoTrigger.js.map